// extracted by mini-css-extract-plugin
module.exports = {"SuccessColor":"SuccessColor_B5QjT","PrimaryColor":"PrimaryColor_abImA"};